export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "content", // 作为 content 的父路由（可选择性保留）
        component: resolve => require(["@/views/content/index.vue"], resolve),
        children: [
          {
            path: "client/list",
            name: "clientList",
            component: resolve => require(["@/modules/client/pages/list.vue"], resolve)
          },
          {
            path: "client/type",
            name: "clientType",
            component: resolve => require(["@/modules/client/pages/type.vue"], resolve)
          }
        ]
      }
    ]
  }
];
